import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import Button from '../../../design-system/Button';

const About: React.FC = (): ReactElement => {
  const navigate = useNavigate();
  return (
    <div className="flex grow flex-col md:flex-row justify-center items-center px-8 py-8 sm:py-16 text-dark overflow-hidden">
      <div className="max-h-[32rem] rounded-full  md:max-w-[50%] aspect-1/1 overflow-hidden">
        <img
          className="w-full"
          src="static/resources/Adriana-3.jpg"
          alt="Portret specialist"
        />
      </div>
      <div className="grow mt-16 md:mt-0 sm:ml-12 lg:ml-20 text-sm md:text-base lg:text-lg max-w-[480px] box-border">
        <p className="text-2xl md:text-3xl lg:text-4xl font-bold">
          Novăcescu Adriana
        </p>
        <p className="text-lg md:text-xl lg:text-2xl font-bold">
          Logoped, Psiholog
        </p>
        <br />
        <p className="text-base md:text-lg lg:text-xl font-bold">
          Experiență profesională:
        </p>
        <p className="leading-9">
          Practicant logopedie începând cu anul 2012 atât în mediul privat cât
          și în sistemul educațional de stat.
        </p>
        <p className="leading-9">Gradul didactic definitiv în învățământ.</p>
        <p className="leading-9">
          Specializare în dislalii și probleme de mobilitate oro-facială.
        </p>
        <p className="leading-9">Specializare în lucru cu copii.</p>
        <p className="leading-9">
          Adaptarea tehnicilor de educație cu empatie și blândețe în muncă și
          motivarea copiilor.
        </p>
        <div className="w-full mt-20 flex justify-center">
          <Button
            variant="solid"
            color="primary"
            className="min-w-[215px]"
            onClick={() => {
              navigate('/prezentare');
              window.scroll(0, 0);
            }}
          >
            Află mai multe
          </Button>
        </div>
      </div>
    </div>
  );
};

export default About;
